module.exports = __webpack_public_path__ + "static/media/skin_recipe.f81b6da4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/books/skin_recipe.svg
// module id = 405
// module chunks = 0